// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanOmnibusBalanceSummaryRecordDto
 */
export interface IPlanOmnibusBalanceSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceSummaryRecordDto
     */
    plan_year?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceSummaryRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceSummaryRecordDto
     */
    funding_type?: string;
    /**
     * 
     * @type {number}
     * @memberof IPlanOmnibusBalanceSummaryRecordDto
     */
    plan_end_of_day_balance?: number;
}

/**
 * Check if a given object implements the IPlanOmnibusBalanceSummaryRecordDto interface.
 */
export function instanceOfIPlanOmnibusBalanceSummaryRecordDto(value: object): value is IPlanOmnibusBalanceSummaryRecordDto {
    return true;
}

export function IPlanOmnibusBalanceSummaryRecordDtoFromJSON(json: any): IPlanOmnibusBalanceSummaryRecordDto {
    return IPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped(json, false);
}

export function IPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanOmnibusBalanceSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_year': json['plan_year'] == null ? undefined : json['plan_year'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'funding_type': json['funding_type'] == null ? undefined : json['funding_type'],
        'plan_end_of_day_balance': json['plan_end_of_day_balance'] == null ? undefined : json['plan_end_of_day_balance'],
    };
}

export function IPlanOmnibusBalanceSummaryRecordDtoToJSON(json: any): IPlanOmnibusBalanceSummaryRecordDto {
    return IPlanOmnibusBalanceSummaryRecordDtoToJSONTyped(json, false);
}

export function IPlanOmnibusBalanceSummaryRecordDtoToJSONTyped(value?: IPlanOmnibusBalanceSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_year': value['plan_year'],
        'plan_name': value['plan_name'],
        'funding_type': value['funding_type'],
        'plan_end_of_day_balance': value['plan_end_of_day_balance'],
    };
}

